import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../modules/shared/store/common/component-store-v2.factory';
import { UserTaskEntryObject } from '@libs/types/src/services/object-type/user/user-task-entry.object';
import { UserTaskAppointmentStatus, UserTaskEntryExtendedObject } from './edit-user-task-item-dialog.types';
import { UserTaskAppointmentObject } from '@libs/types/src/services/object-type/user/user-task-appointment.object';

@Injectable()
export class EditUserTaskItemDialogStore extends ComponentStoreV2Factory {

    public appointments = computed(() => {
        const data = this.data.getUserTaskAppointments()?.['items'];

        if (!data) return null;

        return data.map((it: UserTaskAppointmentObject) => {
            const status = it.completedAt ? it.completedAt < it.date ? UserTaskAppointmentStatus.INTIME : UserTaskAppointmentStatus.LATE : null;
            return {
                ...it,
                status,
            };
        });
    });

    public entries = computed(() => {
        return this.buildTree(this.data.getUserTaskEntries()?.['items']);
    });

    private buildTree(entries: UserTaskEntryObject[] | null): UserTaskEntryExtendedObject[] | null {
        if (!entries) return null;

        // Create a map for quick lookup
        const map = new Map<number, UserTaskEntryExtendedObject>();
        const roots: UserTaskEntryExtendedObject[] = [];

        // First pass: create map and add children property
        entries.forEach(entry => {
            map.set(entry.id, { ...entry, children: [] });
        });

        // Second pass: build the tree
        entries.forEach(entry => {
            const node = map.get(entry.id)!;

            if (!entry.parentId) {
                // Root node
                roots.push(node);
            } else {
                // Child node
                const parent = map.get(entry.parentId);
                if (parent) {
                    parent.children!.push(node);
                } else {
                    // Parent not found, treat as root
                    roots.push(node);
                }
            }
        });

        return roots;
    }
}
